/* LF: LuxCraft FAQ — animated <details> (v25 round 2, §7 task 11)

   <details>/<summary> gives keyboard operation, screen-reader semantics and
   a JS-disabled render for free (see the header comment in
   sections/lf-lc-faq.liquid) — but the browser has no transition for a
   panel's native open/closed height, it just snaps. This intercepts the
   summary click, drives a max-height transition by measuring the panel's
   own scrollHeight, and only touches the `open` attribute at the point in
   each direction where the native semantics need it to already be correct:
   BEFORE the opening animation starts (so the panel is in the layout and
   has a measurable height) and AFTER the closing animation ends (so the
   panel isn't hidden mid-transition by <details> alone).

   Reduced-motion: the transition duration collapses to near-zero via CSS
   (see .lf-lc-faq__panel's own prefers-reduced-motion rule in lf-lc.css),
   so this script's timing logic doesn't need its own branch for it — the
   same code path just resolves almost instantly.

   Scoped per [data-lf-lc-faq] instance and idempotent, matching the
   boot()/lfFpBooted pattern already used by assets/lf-fp.js, so a page that
   somehow rendered this section twice — or a theme-editor re-render —
   cannot double-bind. */
(function () {
  function initFaq(root) {
    if (root.dataset.lfLcFaqBooted === 'true') return;
    root.dataset.lfLcFaqBooted = 'true';

    root.querySelectorAll('[data-lf-lc-faq-item]').forEach(function (item) {
      var summary = item.querySelector(':scope > summary');
      var panel = item.querySelector('[data-lf-lc-faq-panel]');
      if (!summary || !panel) return;

      var animating = false;

      function onEnd(e) {
        if (e && e.target !== panel) return;
        panel.removeEventListener('transitionend', onEnd);
        animating = false;
        if (!item.open) {
          panel.style.height = '';
          panel.style.overflow = '';
        } else {
          panel.style.height = 'auto';
        }
      }

      function open() {
        animating = true;
        item.open = true;
        panel.style.overflow = 'hidden';
        panel.style.height = '0px';
        // Force a layout flush so the browser registers the 0px start
        // point before the height it animates to is applied.
        // eslint-disable-next-line no-unused-expressions
        panel.offsetHeight;
        panel.style.height = panel.scrollHeight + 'px';
        panel.addEventListener('transitionend', onEnd);
      }

      function close() {
        animating = true;
        panel.style.overflow = 'hidden';
        panel.style.height = panel.scrollHeight + 'px';
        // eslint-disable-next-line no-unused-expressions
        panel.offsetHeight;
        panel.style.height = '0px';
        panel.addEventListener('transitionend', function endClose(e) {
          if (e && e.target !== panel) return;
          panel.removeEventListener('transitionend', endClose);
          item.open = false;
          animating = false;
          panel.style.height = '';
          panel.style.overflow = '';
        });
      }

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (animating) return;
        if (item.open) {
          close();
        } else {
          open();
        }
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-lf-lc-faq]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
